// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import React from "react";

const Check: React.FC<{ width?: number; height?: number }> = ({ width = 8, height = 7 }) => {
    return (
        <svg width={width} height={height} viewBox="0 0 8 7">
            <path
                fill="currentColor"
                d="M7.77.1c.25.184.303.52.125.756L3.322 6.78a.653.653 0 0 1-.41.218.642.642 0 0 1-.465-.151L.161 4.692a.546.546 0 0 1 0-.774.633.633 0 0 1 .821 0l1.804 1.717L6.966.217A.616.616 0 0 1 7.77.099Z"
            />
        </svg>
    );
};

export default React.memo(Check);
